/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ParentCompany/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ParentCompany({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/ParentCompany"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let providerAccountDescriptionParentorgnameValueData = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'description.parentOrgName',
})
  return (<React.Fragment
>
<div
  data-testid="ParentCompany.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z2qyXDh': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 width={130}
 color={dtColorsNeutral500}
 text="Parent Organization"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 width={200}
 data="provider_account.description.parentOrgName"
 text={providerAccountDescriptionParentorgnameValueData}
/>
</div>
{children}
</React.Fragment>)
}